<template>
	<el-popover placement="right-start" :width="270" trigger="click" :hide-after="0" :show-after="0" v-bind="$attrs" :teleported="false">
		<template #reference>
			<slot name="reference">
				<el-button type="primary" icon="el-icon-plus" circle></el-button>
			</slot>
		</template>
		<div class="add-node-popover-body">
			<ul>
				<li v-for="(item,index) in actions" :key="index">
					<el-icon style="color: #ff943e;" @click="addType(item)">
						<component :is="item.icon"/>
					</el-icon>
					<p>{{ item.title }}</p>
				</li>
			</ul>
		</div>
	</el-popover>
</template>

<script>
export default {
	props: {
		modelValue: {type: Object, default: () => []},
		actions: {
			type: Array,
		}
	},
	data() {
		return {}
	},
	mounted() {

	},
	methods: {
		addType(type) {
			this.$emit("update:modelValue", {})
		}
	}
}
</script>

<style scoped lang="scss">
.add-node-popover-body {
}

.add-node-popover-body li {
	display: inline-block;
	width: 80px;
	text-align: center;
	padding: 10px 0;
}

.add-node-popover-body li i {
	border: 1px solid var(--el-border-color-light);
	width: 40px;
	height: 40px;
	border-radius: 50%;
	text-align: center;
	line-height: 38px;
	font-size: 18px;
	cursor: pointer;
}

.add-node-popover-body li i:hover {
	border: 1px solid #3296fa;
	background: #3296fa;
	color: #fff !important;
}

.add-node-popover-body li p {
	font-size: 12px;
	margin-top: 5px;
}
</style>
